/**
 * Cover & Snapshot (slide 1) — client-side parser + assembler for the
 * 4 bullets that render at the bottom of the fixed layout.
 *
 * Iter63 (Feb 2026). Content storage is a simple 4-line canonical
 * hyphen-bulleted format so the same string works everywhere (preview,
 * PPTX export, play-deck, premium rewrite).
 *
 *   - Bullet one
 *   - Bullet two
 *   - Bullet three
 *   - Bullet four
 */

export const MAX_COVER_BULLETS = 4;
/** Per-bullet word cap — bottom-of-cover bullets stay short & snappy. */
export const COVER_BULLET_WORD_CAP = 14;

export function parseCoverBullets(content) {
  if (!content) return ["", "", "", ""];
  const lines = content
    .split(/\n/)
    .map((l) => l.replace(/^[-*•●▪]\s*/, "").replace(/^\d+[.)]\s*/, "").trim())
    .filter(Boolean)
    .slice(0, MAX_COVER_BULLETS);
  while (lines.length < MAX_COVER_BULLETS) lines.push("");
  return lines;
}

export function assembleCoverBullets(bullets) {
  const cleaned = (bullets || [])
    .map((b) => (b || "").trim())
    .filter(Boolean)
    .slice(0, MAX_COVER_BULLETS);
  return cleaned.map((b) => `- ${b}`).join("\n");
}

export function countWords(s) {
  if (!s) return 0;
  const t = s.trim();
  return t ? t.split(/\s+/).length : 0;
}
